import React from "react";

export const Distribution = ({ size = "16px" }: { size?: string }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 16L11.95 14.95L13.1313 13.75H7V12.25H13.1313L11.95 11.05L13 10L16 13L13 16Z" fill="#00A9A4" />
            <path
                d="M13.7906 6.65639L16 2.81048L11.1392 0H10.2002C10.0038 0.59168 9.77062 1.1094 9.50058 1.55316C9.23053 1.99692 8.72727 2.2188 7.99079 2.2188C7.25432 2.2188 6.75105 1.99692 6.48101 1.55316C6.21097 1.1094 5.97775 0.59168 5.78136 0H4.84235L0 2.82897L2.19102 6.65639L3.57192 5.89831V15H5.04488V3.38367L2.74338 4.65948L2.0069 3.36518L4.82394 1.71957C5.11853 2.32357 5.55109 2.80431 6.12161 3.16179C6.69263 3.51926 7.31569 3.698 7.99079 3.698C8.6659 3.698 9.28871 3.51926 9.85924 3.16179C10.4303 2.80431 10.8631 2.32357 11.1577 1.71957L13.9931 3.36518L13.2382 4.65948L10.9367 3.38367V9.453C11.6732 8.71341 11.6732 8.71341 11.6732 8.71341L12.4097 7.97381V5.89831L13.7906 6.65639Z"
                fill="#00A9A4"
            />
        </svg>
    );
};
